import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, FormGroup } from '@mui/material';
import { getUserFullName } from '../../utils/user.utils';
import { Autocomplete, TextField } from '@mui/material';

export const CreateUserGroupModal = ({ 
    showAdd, 
    handleCloseAdd, 
    lngsltd, 
    userIDs, 
    setUserIDs, 
    userData, 
    groupIDs, 
    setGroupIDs, 
    groupData, 
    handleSave 
}) => {
    // Handles the checkbox selection change
    const handleGroupChange = (event) => {
        const {
            target: { value },
        } = event;
        setGroupIDs(
            typeof value === 'string' ? value.split(',') : value // Handles both multiple and single values
        );
    };

    return (
        <Dialog open={showAdd} onClose={handleCloseAdd} fullWidth>
            <DialogTitle style={{ backgroundColor: '#efedf0' }}>
                Add User Group
            </DialogTitle>
            <DialogContent>
                {/* USER SELECT */}
                <FormControl fullWidth margin="normal" required>
  <Autocomplete
    multiple
    options={userData}
    getOptionLabel={(option) => getUserFullName(option)}
    value={userData.filter(u => userIDs.includes(u.userID))}
    onChange={(e, value) => setUserIDs(value.map(v => v.userID))}
    renderInput={(params) => (
      <TextField
        {...params}
        label={lngsltd["Select Users"]}
        placeholder="Select Users"
      />
    )}
  />
</FormControl>

                {/* GROUP SELECT WITH CHECKBOXES */}
                <FormControl fullWidth margin="normal" required>
                    <InputLabel>{lngsltd["Select Groups"]}</InputLabel>
                    <Select
                        multiple
                        value={groupIDs}
                        onChange={handleGroupChange}
                        fullWidth
                        label={lngsltd["Select Groups"]}
                        renderValue={(selected) =>
                            selected
                                .map(id =>
                                    groupData.find(g => g.groupID === id)?.groupName
                                )
                                .filter(Boolean)
                                .join(', ')
                        }
                    >
                        {groupData.map((group) => (
                            <MenuItem key={group.groupID} value={group.groupID}>
                                <Checkbox checked={groupIDs.includes(group.groupID)} />
                                <ListItemText primary={group.groupName} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>

            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleSave}>
                    {lngsltd["Add"]}
                </Button>
                <Button variant="outlined" color='error' onClick={handleCloseAdd}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
